import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

import OnboardBanner from 'app/components/icons/OnboardBanner.png'

const useStyles = makeStyles((theme) => ({
  container: {
    height: '600px',
    maxHeight: '90vh',
    [theme.breakpoints.down(900)]: {
      overflow: 'auto',
    },
    [theme.breakpoints.up(900)]: {
      width: '800px',
      maxWidth: '95vw',
    },
  },
  banner: {
    [theme.breakpoints.down(900)]: {
      display: 'none',
    },
    [theme.breakpoints.up(900)]: {
      width: '50%',
      display: 'block',
      backgroundSize: 'cover !important',
      backgroundPosition: 'center !important',
    },
  },
  content: {
    backgroundColor: 'white',
    overflow: 'auto',
    [theme.breakpoints.down(900)]: {
      margin: 'auto',
      padding: '3rem',
      borderRadius: '2.4rem',
      width: 'calc(100vw - 50px)',
      height: '100%',
    },
    [theme.breakpoints.up(900)]: {
      width: '50%',
      padding: '3rem',
      borderTopLeftRadius: '2.4rem',
      borderBottomLeftRadius: '2.4rem',
    },
  },
}))

const IllustrationOnboard = (props) => {
  const { children, className } = props

  const classes = useStyles()

  return (
    <div className={clsx(className, classes.container)}>
      <div className="flex h-full">
        <div className={clsx(classes.content)}>{children}</div>
        <div className={classes.banner}>
          <img
            className="w-full h-full object-cover rounded-r-24"
            src={OnboardBanner}
            alt="Banner"
          />
        </div>
      </div>
    </div>
  )
}

IllustrationOnboard.propTypes = {
  onBack: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  isClickBack: PropTypes.bool,
}

export default IllustrationOnboard
